import round from 'lodash/round';
import Numerical from './Numerical';

const _ = {
  round,
};

const defaultValue = '';

class Percent extends Numerical {
  sanitize(force = false) {
    super.sanitize(force);

    const precision = this.config.precision ? this.config.precision : 2;

    this.value.forEach((val, index) => {
      if (val === undefined || val === null || val === '') {
        this.setValue(defaultValue, index);
        this.setDisplayValue(defaultValue, index);
        return;
      }

      if (force || this.validIndex[index]) {
        let saneValue = parseFloat(_.round(val, precision)).toFixed(precision);
        if (Number.isNaN(saneValue)) {
          saneValue = defaultValue;
        }
        this.setValue(saneValue, index);
        this.setDisplayValue(saneValue, index);
      }
    });

    return this;
  }

  validate() {
    super.validate();

    this.value.forEach((val, index) => {
      if (!this.needsValidation(index)) {
        return;
      }

      if (val > 100 || val < 0) {
        this.invalidate('Invalid percent.', index);
      }
    });

    return this.isValid();
  }
}

export default Percent;
